import styled from 'styled-components';

export const FieldWrapper = styled.div`
  display: ${({ $inline }) => ($inline ? 'flex' : 'block')};
  margin-bottom: ${({ theme }) => theme.spacing.medium};
`;

export const InputWrapper = styled.div`
  margin-bottom: ${({ $noMargin, theme }) =>
    $noMargin ? '0' : theme.spacing.medium};

  > fieldset > div:last-child {
    margin-bottom: 0;
  }
`;
